/**
 * If user is alloed to downlaod any ticket, else redirect back to landing page
 */
export default defineNuxtRouteMiddleware((to) => {
    const localeRoute = useLocaleRoute();
    const { canDownloadTickets } = useLoadEsavBooking(to);

    if (!canDownloadTickets) {
        return navigateTo(localeRoute({ name: 'esav', params: { bookingId: to.params.bookingId as string } }));
    }
});
